import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScUiDropdownComponent } from './scui-dropdown.component';

@NgModule({
  declarations: [ScUiDropdownComponent],
  imports: [
    CommonModule
  ],
  exports: [ScUiDropdownComponent]
})
export class ScuiDropdownModule {
}
